var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('markdown',{attrs:{"value":_vm.issue.releaseNoteDetail,"label":_vm.$t('issues.actions.add_releaseDetail'),"allow-editing":this.allowEditing},on:{"save-content":_vm.changeAttribute}})}
var staticRenderFns = []

export { render, staticRenderFns }